<template>
  <div class="service-faq">
    <search-result :facets="facets" :grouped="'type'" :options="{ language: true , sortings: false}" hide-categories>
      <template v-slot:results="props">

        <search-result-group :raw-results="group.results"  v-for="(group,groupId) in props.groups" :headline="$t('service_download.types.' + groupId)">

          <template v-slot:result="props">
            <div class="col-sm-12">
              <faq-result-entry :result="props.result"></faq-result-entry>
            </div>
          </template>
        </search-result-group>

      </template>
      <!--            <template v-slot:additionalFilter="props">-->
      <!--                <div class="col-sm-4">-->
      <!--                    <filter-category-label-cloud :results="results" ></filter-category-label-cloud>-->
      <!--                </div>-->
      <!--            </template>-->
    </search-result>
  </div>
</template>

<script>
import SearchResult from './SearchResult';
import FaqResultEntry from "@/components/FaqResultEntry";
import SearchResultGroup from "./SearchResultGroup";
import FilterCategoryLabelCloud from "@/components/FilterCategoryLabelcloud";
import FilterFacetTypeId from "@/components/FilterFacetTypeId";

let scrollOptions = {
  force: true,
  cancelable: true,
  offset: -200
};

export default {
  name: "ServiceFaq",
  components: {
    FilterCategoryLabelCloud,
    SearchResultGroup,
    FaqResultEntry,
    SearchResult
  },
  data: function () {
    return {
      dummy: "test",
      watching: null,
      resultTypes: {default: FaqResultEntry},
      sortings: [
        'asc', 'desc', 'date', 'relevance'
      ],
      selections: {
        searchFilter: [],
        languageFilter: [],
      },
      sorting: 'relevance',
      facets: [
        {
          component: FilterFacetTypeId,
          binding: 'categories',
          classes: ['col-sm-4'],
          facetName: 'level_0',
          getOptionName: function (id) {
            let filter = this.$options.filters.category;
            let name = filter(id);
            return name;
          }
        },{
          component: FilterFacetTypeId,
          binding: 'type_id',
          classes: ['col-sm-5'],
          facetName: 'type_id',
          getOptionName: function (id) {
            return this.$t("service_download.types." + id.replace('.',':'));
          }
        },
        // {
        //   component: FilterCategoryLabelCloud,
        //   binding: 'categories',
        //   classes: ['col-sm-3'],
        //   facetName: 'level_0',
        //   getOptionName: function (id) {
        //     return this.$t("service_faq.types." + id);
        //   }
        // }

        // ,{
        //   component: FilterFacetTypeId,
        //   binding: 'lang',
        //   classes: ['col-sm-3'],
        //   facetName: 'lang',
        //   getOptionName: function (id) {
        //     return id.toUpperCase();
        //   },
        //   filterOptions(option) {
        //     return option.toLowerCase() !== 'nn';
        //   }
        // }
      ]
    };
  },
  computed: {
    resultState() {
      return this.$store.state.status.results;
    },
    results() {
      return this.$store.state.results;
    }
  },
  watch: {
    watching() {

    },
    resultState() {

    }
  },
  methods: {

  },
  created() {
    this.$store.commit('selectService', 'faq');
    this.$store.commit('results', null);

    Promise.all([this.$store.dispatch('fetchCategories'), this.$store.dispatch('getResults')]);
  }
}

</script>

<style scoped>

</style>
